import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  const item = aboutData[0];

  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            {item.title}
          </h2>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="space-y-4 md:space-y-5">
            {item.paragraphs.map((p, index) => (
              <p key={index} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="mt-8 md:mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
            {item.stats.map((stat) => (
              <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">
                  {stat.value}
                </div>
                <div className="mt-1 text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}